import './continue-request.scss';

import { notification } from 'antd';
import { useTranslation } from 'react-i18next';

import { setRequestToContinue } from '@/components/Client/AutoCredit/auto-credit.store';
import { Modal } from '@/components/Client/AutoCredit/shared/ui';
import {
  CLIENT_ROUTES,
  getFullClientRoute
} from '@/components/Shared/routes/routes';
import { Button } from '@/components/Shared/ui';
import useAppNavigate from '@/hooks/useAppNavigation';
import { getClientToken } from '@/services/user-hash';
import { useAppDispatch, useAppSelector } from '@/store';

const ContinueRequest: React.FC = () => {
  const { navigate } = useAppNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { requestToContinue } = useAppSelector(
    (state) => state.clientAutoCredit
  );

  const handleCloseContinueRequest = () => {
    dispatch(setRequestToContinue(''));
  };

  const handleContinueRequest = () => {
    const userHash = getClientToken();
    if (userHash) {
      navigate(
        getFullClientRoute(CLIENT_ROUTES.autoCreditRequest(requestToContinue))
      );
    } else {
      notification.error({
        message: t('client.continue-request-error-title'),
        description: t('client.continue-request-error-description')
      });
      navigate(getFullClientRoute(CLIENT_ROUTES.autoCreditCreate));
    }
    handleCloseContinueRequest();
  };

  return (
    <Modal
      title={t('client.continue-request-modal-title')}
      open={!!requestToContinue}
      onClose={handleCloseContinueRequest}
    >
      {({ classes }) => (
        <div>
          <p className="continue-request__text">
            {t('client.continue-request-modal-text')}
          </p>

          <div className={classes.actions}>
            <Button onClick={handleCloseContinueRequest}>
              {t('client.continue-request-modal-cancel')}
            </Button>
            <Button variant="filled-primary" onClick={handleContinueRequest}>
              {t('client.continue-request-modal-confirm')}
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ContinueRequest;
